<template>
  <div class="details-popover">
    <div v-loading="loading" element-loading-spinner="nucleus-loader" style="min-height: 280px;">
      <div v-if="!loading">
        <div v-if="!isCoding">
          <el-table style="height: 280px;" v-show="tableType === 'binary' || tableType === 'stats'" :data="popOverData">
            <el-table-column prop="title" :label="header"> </el-table-column>
            <el-table-column prop="value" label="">
              <template slot-scope="scope">
                <div v-if="scope.row.title === 'RVU Difference'" :class="scope.row.value < 0 ? 'negativeNumber' : ''">
                  {{ scope.row.value }}
                </div>
                <div v-else-if="(scope.row.title === 'Original Work RVU' && scope.row.value === null) || (scope.row.title === 'Recommended Work RVU' && scope.row.value === null)">
                  N/A
                </div>
                <div v-else :class="canOpenDetails(scope.row) ? 'details' : ''" :title="canOpenDetails(scope.row) ? 'View Records and Worksheets' : ''" @click="canOpenDetails(scope.row) && handleFilterClick(scope.row)">{{ scope.row.value }}</div>
              </template>
            </el-table-column>
          </el-table>

          <el-table style="height: auto;" v-show="tableType === 'financial'" :data="popOverData">
            <el-table-column prop="title" :label="header" width="210"> </el-table-column>
            <el-table-column prop="value" label="">
              <template slot-scope="scope">
                <div v-if="scope.row.title !== 'Reimbursement Decrease Records' && scope.row.title !== 'Reimbursement Increase Records'" :class="scope.row.value < 0 ? 'negative' : ''">${{ formatMoney(scope.row.value) }}</div>
                <div v-else :class="canOpenDetails(scope.row) ? 'details' : ''" :title="canOpenDetails(scope.row) ? 'View Records and Worksheets' : ''" @click="canOpenDetails(scope.row) && handleFilterClick(scope.row)">{{ scope.row.value }}</div>
              </template>
            </el-table-column>
          </el-table>

          <el-table style="height: auto;" v-show="tableType === 'dataStats'" :data="popOverData">
            <el-table-column prop="title" :label="header" width="210"> </el-table-column>
            <el-table-column prop="value" label="">
              <template slot-scope="scope">
                <div v-if="scope.row.title !== 'Number of Records' && scope.row.title !== 'Record Recommendations'" :class="scope.row.value < 0 ? 'negative' : ''">${{ formatMoney(scope.row.value) }}</div>
                <div v-else :class="canOpenDetails(scope.row) ? 'details' : ''" :title="canOpenDetails(scope.row) ? 'View Records and Worksheets' : ''" @click="canOpenDetails(scope.row) && handleFilterClick(scope.row)">{{ scope.row.value }}</div>
              </template>
            </el-table-column>
          </el-table>

          <el-table style="height: auto;" v-show="tableType === 'proDataStats'" :data="popOverData">
            <el-table-column prop="title" :label="header" width="210"> </el-table-column>
            <el-table-column prop="value" label="">
              <template slot-scope="scope">
                <div v-if="scope.row.title === 'RVU Difference'" :class="scope.row.value < 0 ? 'negativeNumber' : ''">
                  {{ scope.row.value }}
                </div>
                <div v-else-if="(scope.row.title === 'Original Work RVU' && scope.row.value === null) || (scope.row.title === 'Recommended Work RVU' && scope.row.value === null)">
                  N/A
                </div>
                <div v-else :class="canOpenDetails(scope.row) ? 'details' : ''" :title="canOpenDetails(scope.row) ? 'View Records and Worksheets' : ''" @click="canOpenDetails(scope.row) && handleFilterClick(scope.row)">{{ scope.row.value }}</div>
              </template>
            </el-table-column>
          </el-table>

          <small v-if="header === 'Total Codes' && reviewType === 'ip'" style="font-style: italic; margin: 5px 0px 0px 10px; display: inline-block;">*Total Codes is calculated using CM and PCS codes</small>

          <small v-if="header === 'Total Codes' && reviewType === 'op'" style="font-style: italic; margin: 5px 0px 0px 10px; display: inline-block;">*Total Codes is calculated using CM, PCS, CPT, MOD, E/M, I&I and S&I codes</small>

          <small v-if="header === 'Total Codes' && reviewType === 'pro'" style="font-style: italic; margin: 5px 0px 0px 10px; display: inline-block;">*Total Codes is calculated using CM, E/M, CPT and Modifier codes</small>

          <div v-show="reviewType === 'ip' && ['additionsAccounts', 'deletionsAccounts', 'noRecAccounts', 'accountNumbers'].some(s => s === tableType)">
            <div class="details-popover-title" style="float: left; text-align: left; margin: 0px 0px 10px 10px;">Account Numbers for {{ header }}</div>
            <div style="float: right; margin: 0px 0px 0px 0px;">
              <el-button @click="handleArrayToCsv()" plain><i class="mdi mdi-file-download-outline tableIcon"></i>Download CSV </el-button>
            </div>
            <div style="float: right; margin: 0px 10px 10px 0px;">
              <el-input prefix-icon="el-icon-search" size="mini" placeholder="Search Query..." type="text" class="globalSearch" v-model="filterCriteria"> </el-input>
            </div>
            <el-table :data="isIE11 ? filterList(dashboardAccountsPagination, filterCriteria, ['dschDate', 'patNum', 'payName', 'description', 'orDrg', 'neDrg']).sort(sortByOrder) : filterList(localDashboardAccounts, filterCriteria, ['dschDate', 'patNum', 'payName', 'description', 'orDrg', 'neDrg']).sort(sortByOrder)" height="280px" ref="ipList">
              <el-table-column prop="patNum" label="Patient Number">
                <template slot-scope="scope">
                  <template v-if="$route.name === 'my-projects' && getRecordLinkId(scope.row)">
                    <router-link :to="`/${currentClientId}/my-projects/inpatient/${getRecordLinkId(scope.row)}`">{{ scope.row.patNum }}</router-link>
                  </template>
                  <template v-else>
                    <div v-html="highlightValue(scope.row.patNum, filterCriteria)"></div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column prop="payName" label="Payor">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.payName, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="dschDate" label="Discharge Date">
                <template slot-scope="scope">
                  <div v-html="highlightValue(formatDate(scope.row.dschDate), filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="rfc" label="Reason For Change">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.description, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="facDRG" label="Facility DRG">
                <template slot-scope="scope">
                  <div :title="scope.row.orDrgDesc" v-html="highlightValue(scope.row.orDrgDisplay, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="hiaDrg" label="HIA DRG">
                <template slot-scope="scope">
                  <div :title="scope.row.neDrgDesc" v-html="highlightValue(scope.row.neDrgDisplay, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  <el-button-group class="worksheet-button-group">
                    <el-button class="worksheet-button-group-main" @click.stop="handleViewWorksheets(scope.row)" plain :type="isSelectedRecord(scope.row) ? 'primary' : ''"><i class="mdi mdi-file-document-outline tableIcon"></i>Worksheet</el-button>
                    <el-button class="worksheet-button-group-action" @click.stop="handleOpenWorksheetPdf(scope.row)" plain :type="isSelectedRecord(scope.row) ? 'primary' : ''" title="Open worksheet in new window"><i class="mdi mdi-open-in-new tableIcon"></i></el-button>
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>
            <div id="accountNumberTableStats">
              <p>{{ accountNumberTableStats() }}</p>
            </div>

            <el-pagination class="pager" v-if="isIE11" background :pager-count="15" layout="prev, pager, next, slot" :page-size="itemsPerPage" :total="localDashboardAccounts.length" @current-change="handleCurrentChange" :hide-on-single-page="hideOnSinglePage" small> </el-pagination>
          </div>

          <div v-show="reviewType === 'op' && tableType === 'accountNumbers'">
            <div class="details-popover-title" style="float: left;text-align: left; margin: 0px 0px 10px 10px;">Account Numbers for {{ header }}</div>
            <div style="float: right; margin: 0px 0px 0px 0px;">
              <el-button @click="handleArrayToCsv()" plain><i class="mdi mdi-file-download-outline tableIcon"></i>Download CSV </el-button>
            </div>
            <div style="float: right; margin: 0px 10px 10px 0px;">
              <el-input prefix-icon="el-icon-search" size="mini" placeholder="Search Query..." type="text" class="globalSearch" v-model="filterCriteria"> </el-input>
            </div>
            <el-table :data="isIE11 ? filterList(dashboardAccountsPagination, filterCriteria).sort(sortByOrder) : filterList(localDashboardAccounts, filterCriteria).sort(sortByOrder)" height="280px" ref="opList">
              <el-table-column prop="patNum" label="Patient Number">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.patNum, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="patType" label="Patient Type">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.patType, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="payName" label="Payor">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.payName, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="servDate" label="Date of Service">
                <template slot-scope="scope">
                  <div v-html="highlightValue(formatDate(scope.row.servDate), filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="rfc" label="Reason For Change">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.changeDesc, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  <el-button-group class="worksheet-button-group">
                    <el-button class="worksheet-button-group-main" @click.stop="handleViewWorksheets(scope.row)" plain :type="isSelectedRecord(scope.row) ? 'primary' : ''"><i class="mdi mdi-file-document-outline tableIcon"></i>Worksheet</el-button>
                    <el-button class="worksheet-button-group-action" @click.stop="handleOpenWorksheetPdf(scope.row)" plain :type="isSelectedRecord(scope.row) ? 'primary' : ''" title="Open worksheet in new window"><i class="mdi mdi-open-in-new tableIcon"></i></el-button>
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>
            <div id="accountNumberTableStats">
              <p>{{ accountNumberTableStats() }}</p>
            </div>
            <el-pagination class="pager" v-if="isIE11" background :pager-count="15" layout="prev, pager, next, slot" :page-size="itemsPerPage" :total="localDashboardAccounts.length" @current-change="handleCurrentChange" :hide-on-single-page="hideOnSinglePage" small> </el-pagination>
          </div>

          <div v-show="reviewType === 'pro' && tableType === 'accountNumbers'">
            <div class="details-popover-title" style="float: left;text-align: left; margin: 0px 0px 10px 10px;">Account Numbers for {{ header }}</div>
            <div style="float: right; margin: 0px 0px 0px 0px;">
              <el-button @click="handleArrayToCsv()" plain><i class="mdi mdi-file-download-outline tableIcon"></i>Download CSV </el-button>
            </div>
            <div style="float: right; margin: 0px 10px 10px 0px;">
              <el-input prefix-icon="el-icon-search" size="mini" placeholder="Search Query..." type="text" class="globalSearch" v-model="filterCriteria"> </el-input>
            </div>
            <el-table :data="isIE11 ? filterList(dashboardAccountsPagination, filterCriteria).sort(sortByOrder) : filterList(localDashboardAccounts, filterCriteria).sort(sortByOrder)" height="280px" ref="opList">
              <el-table-column prop="patNum" label="Patient Number">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.patNum, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="patType" label="Patient Type">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.patType, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="payName" label="Payor">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.payName, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="servDate" label="Date of Service">
                <template slot-scope="scope">
                  <div v-html="highlightValue(formatDate(scope.row.servDate), filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="rfc" label="Reason For Change">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.changeDesc, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  <el-button-group class="worksheet-button-group">
                    <el-button class="worksheet-button-group-main" @click.stop="handleViewWorksheets(scope.row)" plain :type="isSelectedRecord(scope.row) ? 'primary' : ''"><i class="mdi mdi-file-document-outline tableIcon"></i>Worksheet</el-button>
                    <el-button class="worksheet-button-group-action" @click.stop="handleOpenWorksheetPdf(scope.row)" plain :type="isSelectedRecord(scope.row) ? 'primary' : ''" title="Open worksheet in new window"><i class="mdi mdi-open-in-new tableIcon"></i></el-button>
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>
            <div id="accountNumberTableStats">
              <p>{{ accountNumberTableStats() }}</p>
            </div>
            <el-pagination class="pager" v-if="isIE11" background :pager-count="15" layout="prev, pager, next, slot" :page-size="itemsPerPage" :total="localDashboardAccounts.length" @current-change="handleCurrentChange" :hide-on-single-page="hideOnSinglePage" small> </el-pagination>
          </div>

          <div v-show="tableType === 'dxDashboard'">
            <div class="details-popover-title" style="float: left;text-align: left; margin: 0px 0px 10px 10px;">Dx Summary for {{ header }}</div>
            <div style="float: right; margin: 0px 0px 0px 0px;">
              <el-button @click="handleArrayToCsv()" plain><i class="mdi mdi-file-download-outline tableIcon"></i>Download CSV </el-button>
            </div>
            <div style="float: right; margin: 0px 10px 10px 0px;">
              <el-input prefix-icon="el-icon-search" size="mini" placeholder="Search Query..." type="text" class="globalSearch" v-model="filterCriteria"> </el-input>
            </div>
            <el-table :data="filterList(dxModalData, filterCriteria)" height="280px" ref="dxList">
              <el-table-column prop="codeDesc" label="Code Type" v-if="reviewType !== 'ip'">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="code" label="Code">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="description" label="Description">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.description, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="totalRecords" label="Total Instances">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="accuracyRate" label="Accuracy Rate">
                <template slot-scope="scope">
                  {{ !isNaN(scope.row.accuracyRate) ? (scope.row.accuracyRate * 100).toFixed(2) + '%' : null }}
                </template>
              </el-table-column>
            </el-table>
            <div id="accountNumberTableStats">
              <p>{{ filterList(dxModalData, filterCriteria) ? filterList(dxModalData, filterCriteria).length + ' Codes' : null }}</p>
            </div>
            <el-pagination class="pager" v-if="isIE11" background :pager-count="15" layout="prev, pager, next, slot" :page-size="itemsPerPage" :total="localDashboardAccounts.length" @current-change="handleCurrentChange" :hide-on-single-page="hideOnSinglePage" small> </el-pagination>
          </div>
        </div>
        <div v-else>
          <div v-show="isCoding">
            <div class="details-popover-title" style="float: left;text-align: left; margin: 0px 0px 10px 10px;">{{ header }}</div>
            <div style="float: right; margin: 0px 0px 0px 0px;">
              <el-button @click="handleArrayToCsv()" plain><i class="mdi mdi-file-download-outline tableIcon"></i>Download CSV </el-button>
            </div>
            <div style="float: right; margin: 0px 10px 10px 0px;">
              <el-input prefix-icon="el-icon-search" size="mini" placeholder="Search Query..." type="text" class="globalSearch" v-model="filterCriteria"> </el-input>
            </div>
            <el-table :data="isIE11 ? filterList(dashboardAccountsPagination, filterCriteria).sort(sortByOrder) : filterList(localDashboardAccounts, filterCriteria).sort(sortByOrder)" height="280px" ref="codingList">
              <el-table-column prop="patientAccountNumber" label="Pt. Number">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.patientAccountNumber, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="codingDate" label="Coding Date">
                <template slot-scope="scope">
                  <div v-html="highlightValue(formatDate(scope.row.codingDate), filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="dateOfService" label="Date of Service">
                <template slot-scope="scope">
                  <div v-html="highlightValue(formatDate(scope.row.dateOfService), filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="providerName" label="Provider">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.providerName, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="cdiName" label="CDI Staff">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.cdiName, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="consultantNumber" label="Consultant">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.consultantNumber, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="payor" label="Payor">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.payor, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="patientType" label="Pt. Type">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.patientType, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="drGorAPC" label="DRG/APC">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.drGorAPC, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="pendingReason" label="Pending Reason">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.pendingReason, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="comments" label="Comments" width="200">
                <template slot-scope="scope">
                  <div :title="scope.row.comments" style="text-overflow: ellipsis; white-space: nowrap;" v-html="highlightValue(scope.row.comments, filterCriteria)"></div>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination class="pager" v-if="isIE11" background :pager-count="15" layout="prev, pager, next, slot" :page-size="itemsPerPage" :total="localDashboardAccounts.length" @current-change="handleCurrentChange" :hide-on-single-page="hideOnSinglePage" small> </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div v-if="selectedRecordId" class="record-detail-panel">
      <div class="details-popover-title record-detail-panel-title">Worksheet Details</div>
      <coderInpatientReviewPage v-if="reviewType === 'ip'" :embedded="true" :recordId="selectedRecordId" />
      <coderOutpatientReviewPage v-else-if="reviewType === 'op'" :embedded="true" :recordId="selectedRecordId" />
      <coderProReviewPage v-else-if="reviewType === 'pro'" :embedded="true" :recordId="selectedRecordId" />
    </div>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'
import money from '@/mixins/money'
import { mapState, mapActions } from 'vuex'
import hiaFilters from '@/mixins/hiaFilters'
import csvGenerator from '@/mixins/csvGenerator'
import coderInpatientReviewPage from '@/views/MyProjects/inpatient/coderInpatientReviewPage'
import coderOutpatientReviewPage from '@/views/MyProjects/outpatient/coderOutpatientReviewPage'
import coderProReviewPage from '@/views/MyProjects/pro/coderProReviewPage'

// Filter configuration maps
const VALUE_KEY_MAP = {
  dx: 'code',
  px: 'code',
  hcc: 'code',
  coder: 'coder',
  coderTrending: 'coder',
  facility: 'cliName',
  drg: 'orDrg',
  patientType: 'patTypeDesc',
  reason: 'changeReason',
  serviceLine: 'clientServiceLineName',
  opdx: 'code',
  oppx: 'code',
  opcpt: 'code',
  opmod: 'code',
  ophcc: 'code',
  ophccv28: 'code',
  opCoder: 'coder',
  opCoderTrending: 'coder',
  opFacility: 'cliName',
  opServiceLine: 'clientServiceLineName',
  headerreason: 'changeReason',
  opReason: 'description',
  code: 'patTypeDesc',
  codeType: 'apc',
  proCoder: 'coder',
  proCoderTrending: 'coder',
  proProvider: 'physicianName',
  proProviderTrending: 'physicianName',
  propattype: 'patTypeDesc',
  proFacility: 'cliName',
  proheaderreason: 'changeReason',
  proServiceLine: 'clientServiceLineName',
  prodx: 'code',
  prosdoh: 'code',
  prohcc: 'code',
  prohccv28: 'code',
  procpt: 'code',
  promod: 'code',
  proem: 'code',
  proemLevelSumm: 'reason',
  proReason: 'description',
  ambCoder: 'coder',
  ambCoderTrending: 'coder',
  ambFacility: 'cliName',
  ambcode: 'patTypeDesc',
  ambReason: 'description',
  ambheaderreason: 'changeReason',
  ambdx: 'code',
  ambhcc: 'code',
  ambhccv28: 'code',
  ambcpt: 'code',
  ambmod: 'code',
  ambpx: 'code',
  ambServiceLine: 'clientServiceLineName'
}

const STAT_TYPE_MAP = {
  poaCodes: 'POA',
  cmCodes: 'Dx',
  pcsCodes: 'Px',
  cptCodes: 'CPT',
  modCodes: 'MOD',
  apcCodes: 'APC',
  emCodes: 'E/M',
  iiCodes: 'I&I',
  siCodes: 'S&I',
  cptCodesWReimb: 'CPT With Reimb',
  cptCodesWOReimb: 'CPT Without Reimb',
  hccV24AccuracyRate: 'HCC V24',
  hccV28AccuracyRate: 'HCC V28',
  accuracyRate: 'Accuracy',
  totalDRGs: 'Total DRGs',
  totalDRGNoQuery: 'Total DRG No Query',
  ipTotalCodes: 'Total Codes',
  opTotalCodes: 'Total Codes',
  proTotalCodes: 'Total Codes',
  patStatCodes: 'Patient Status',
  pooCodes: 'Point of Origin',
  reimbDiff: '',
  mainDashboardGrouping: ''
}

const TITLE_TO_FILTER_TYPE = {
  Deletions: 'deletions',
  Additions: 'additions',
  'No Recommendations': 'noRec',
  Revisions: 'revisions',
  'Reimbursement Decrease Records': 'reimbDecRecords',
  'Reimbursement Increase Records': 'reimbIncRecords',
  'Record Recommendations': 'recordRecs'
}

const REVIEW_TYPE_MAP = {
  ip: 'inpatient',
  op: 'outpatient',
  pro: 'pro'
}

export default {
  data: function() {
    return {
      loading: false,
      accountToggle: false,
      selectedRecordId: null,
      filterCriteria: '',
      currentPage: 1,
      itemsPerPage: 30,
      isIE11: !!navigator.userAgent.match(/Trident\/7\./),
      hideOnSinglePage: true
    }
  },
  name: 'DetailsPopOver',
  mixins: [money, hiaFilters, csvGenerator],
  props: {
    header: { type: String },
    popOverData: { type: Array },
    tableType: { type: String },
    reviewType: { type: String },
    statType: { type: String, default: '' },
    isCoding: { type: Boolean, default: false },
    row: { type: Object },
    rowMeta: { type: Object },
    isOpen: { type: Boolean },
    isModal: { type: Boolean, default: false }
  },
  components: {
    coderInpatientReviewPage,
    coderOutpatientReviewPage,
    coderProReviewPage
  },
  methods: {
    ...mapActions('dashboard/', ['GET_DASHBOARD_ACCOUNTS', 'GET_DX_DASHBOARD_BY_HCC', 'GET_DASHBOARD_ACCOUNTS_FINALIZED', 'POST_FILTER_ACCOUNTS', 'GET_WORKSHEET_PDF_URL']),
    handleViewAccountNumbers() {
      let payload = {
        reviewType: this.isCoding ? 'coding' : this.reviewType,
        accountNumbers: this.row.accountNumbers
      }
      if (this.reviewType === 'final') {
        payload.reviewType = 'final'
      }
      this.loading = true
      if (this.reviewType !== 'final') {
        this.GET_DASHBOARD_ACCOUNTS(payload).then(x => {
          this.loading = false
        })
      } else {
        payload.startDate = this.codingDateRange[0]
        payload.endDate = this.codingDateRange[1]
        this.GET_DASHBOARD_ACCOUNTS_FINALIZED(payload).then(x => {
          this.loading = false
        })
      }
    },
    handleFilterClick(clickedRow) {
      const statType = this.rowMeta.prop
      const rowType = this.rowMeta.table
      const valueKey = VALUE_KEY_MAP[rowType] || 'code'
      const isSummary = rowType === 'summary'

      if (clickedRow.title === 'Number of Records') {
        const accountPayload = {
          reviewType: this.reviewType,
          accountNumbers: this.row.accountNumbers
        }
        this.loading = true
        return this.GET_DASHBOARD_ACCOUNTS(accountPayload).then(() => {
          this.loading = false
          this.$emit('headerChange', `${isSummary ? 'Total' : this.row[valueKey] || ''} ${clickedRow.title}`.trim())
          this.$emit('tableTypeChange', 'accountNumbers')
        })
      }

      const filterType = TITLE_TO_FILTER_TYPE[clickedRow.title]
      if (!filterType || !this.row || !this.row.accountNumbers) {
        return
      }

      if (isSummary) {
        const knownAccountNumbers = [...new Set(this.row.accountNumbers.split(',').map(id => parseInt(id, 10)))]
        const apiReviewType = REVIEW_TYPE_MAP[this.reviewType] || this.reviewType

        const filterPayload = {
          filters: [{ dimension: 'reviewType', value: apiReviewType, filterType: null }, { dimension: statType, value: null, filterType: filterType }],
          knownAccountNumbers: knownAccountNumbers
        }

        this.loading = true
        this.POST_FILTER_ACCOUNTS(filterPayload)
          .then(response => {
            const filteredIds = response.data
            if (!filteredIds || !filteredIds.length) {
              this.loading = false
              return
            }

            const accountPayload = {
              reviewType: this.reviewType,
              accountNumbers: filteredIds.join(',')
            }

            return this.GET_DASHBOARD_ACCOUNTS(accountPayload).then(() => {
              this.loading = false
              const statTypeLabel = STAT_TYPE_MAP[statType] ? `${STAT_TYPE_MAP[statType]} ` : ''
              this.$emit('headerChange', `Total ${statTypeLabel}${clickedRow.title}`.trim())
              this.$emit('tableTypeChange', 'accountNumbers')
            })
          })
          .catch(error => {
            console.log('Filter accounts error:', error)
            this.loading = false
          })
        return
      }

      if (!statType || !rowType) {
        return
      }

      const knownAccountNumbers = [...new Set(this.row.accountNumbers.split(',').map(id => parseInt(id, 10)))]
      const apiReviewType = REVIEW_TYPE_MAP[this.reviewType] || this.reviewType

      const filterPayload = {
        filters: [{ dimension: 'reviewType', value: apiReviewType, filterType: null }, { dimension: statType, value: this.row.code, filterType: filterType }],
        knownAccountNumbers: knownAccountNumbers
      }

      if (this.rowMeta && this.rowMeta.codeNumber != null) {
        filterPayload.filters.splice(1, 0, { dimension: 'codeNumber', value: String(this.rowMeta.codeNumber), filterType: null })
      }

      this.loading = true
      this.POST_FILTER_ACCOUNTS(filterPayload)
        .then(response => {
          const filteredIds = response.data
          if (!filteredIds || !filteredIds.length) {
            this.loading = false
            return
          }

          const accountPayload = {
            reviewType: this.reviewType,
            accountNumbers: filteredIds.join(',')
          }

          return this.GET_DASHBOARD_ACCOUNTS(accountPayload).then(() => {
            this.loading = false
            const statTypeLabel = STAT_TYPE_MAP[statType] ? `${STAT_TYPE_MAP[statType]} ` : ''
            this.$emit('headerChange', `${this.row[valueKey]} ${statTypeLabel}${clickedRow.title}`)
            this.$emit('tableTypeChange', 'accountNumbers')
          })
        })
        .catch(error => {
          console.log('Filter accounts error:', error)
          this.loading = false
        })
    },
    isClickableTitle(title) {
      return ['No Recommendations', 'Additions', 'Deletions', 'Revisions', 'Reimbursement Decrease Records', 'Reimbursement Increase Records', 'Record Recommendations', 'Number of Records'].includes(title)
    },
    canOpenDetails(row) {
      return this.isClickableTitle(row.title) && Number(row.value) !== 0
    },
    handleDxDashboard() {
      let payload = {
        reviewType: this.isCoding ? 'coding' : this.reviewType,
        accountNumbers: this.row.accountNumbers,
        hcc: this.row.code,
        hccVersion: this.row.hccVersion
      }
      this.loading = true

      this.GET_DX_DASHBOARD_BY_HCC(payload).then(response => {
        this.loading = false
      })
    },
    getRecordLinkId(row) {
      switch (this.reviewType) {
        case 'ip':
          return row.drgtableId || row.drgTableId
        case 'op':
          return row.ascTableID || row.ascTableId
        case 'pro':
          return row.proRecordId
        default:
          return null
      }
    },
    handleViewWorksheets(row) {
      const id = this.getRecordLinkId(row)
      if (id != null) {
        this.selectedRecordId = id
      }
    },
    handleOpenWorksheetPdf(row) {
      const id = this.getRecordLinkId(row)
      if (id == null) {
        return
      }
      const loading = this.$loading({
        lock: true,
        text: 'Getting ready...',
        spinner: 'nucleus-loader',
        background: 'rgba(255, 255, 255, 0.7)'
      })
      this.GET_WORKSHEET_PDF_URL({ reviewType: this.reviewType, id }).then(response => {
        loading.close()
        window.open(`/static/pdfjs/web/viewer.html?file=${response}`, '_blank')
      }).catch(() => {
        loading.close()
      })
    },
    isSelectedRecord(row) {
      if (this.selectedRecordId == null) {
        return false
      }
      switch (this.reviewType) {
        case 'ip':
          return String(row.drgtableId || row.drgTableId) === String(this.selectedRecordId)
        case 'op':
          return String(row.ascTableID || row.ascTableId) === String(this.selectedRecordId)
        case 'pro':
          return String(row.proRecordId) === String(this.selectedRecordId)
        default:
          return false
      }
    },
    formatDate(date) {
      if (date) {
        return format(parseISO(date), 'MM/dd/yyyy')
      }
      return ''
    },
    accountNumberTableStats() {
      // check for totalOccurences
      return this.row.totalOccurrences ? `${this.filterList(this.localDashboardAccounts, this.filterCriteria).length} Records / ${this.row.totalOccurrences} Total Occurences` : `${this.filterList(this.localDashboardAccounts, this.filterCriteria).length} Records`
    },
    handleArrayToCsv() {
      let headers = []
      let table = null

      if (this.tableType === 'dxDashboard') {
        headers = [{ key: 'Code Type', value: 'Code Type' }, { key: 'Code', value: 'Code' }, { key: 'Description', value: 'Description' }, { key: 'Total Instances', value: 'Total Instances' }, { key: 'Accuracy Rate', value: 'Accuracy Rate' }]
        table = this.$refs.dxList.$el
        this.tableToCsv(table, 'dx_codes.csv', headers)
        return
      }

      if (this.reviewType === 'ip') {
        headers = [{ key: 'Patient Number', value: 'Patient Number' }, { key: 'Payor', value: 'Payor' }, { key: 'Discharge Date', value: 'Discharge Date' }, { key: 'Reason For Change', value: 'Reason For Change' }, { key: 'Facility DRG', value: 'Facility DRG' }, { key: 'HIA DRG', value: 'HIA DRG' }]
        table = this.$refs.ipList.$el
      } else if (this.reviewType === 'op') {
        headers = [{ key: 'Patient Number', value: 'Patient Number' }, { key: 'Patient Type', value: 'Patient Type' }, { key: 'Payor', value: 'Payor' }, { key: 'Date of Service', value: 'Date of Service' }, { key: 'Reason For Change', value: 'Reason For Change' }]
        table = this.$refs.opList.$el
      } else if (this.reviewType === 'pro') {
        headers = [{ key: 'Patient Number', value: 'Patient Number' }, { key: 'Patient Type', value: 'Patient Type' }, { key: 'Payor', value: 'Payor' }, { key: 'Date of Service', value: 'Date of Service' }, { key: 'Reason For Change', value: 'Reason For Change' }]
        table = this.$refs.opList.$el
      } else if (this.isCoding) {
        headers = [{ key: 'Pt. Number', value: 'Patient Number' }, { key: 'Coding Date', value: 'Coding Date' }, { key: 'Date of Service', value: 'Date of Service' }, { key: 'Provider', value: 'Provider' }, { key: 'CDI Staff', value: 'CDI Staff' }, { key: 'Consultant', value: 'Consultant' }, { key: 'Pt. Type', value: 'Pt. Type' }, { key: 'Payor', value: 'Payor' }, { key: 'DRG/APC', value: 'DRG/APC' }, { key: 'Pending Reason', value: 'Pending Reason' }, { key: 'Comments', value: 'Comments' }]
        table = this.$refs.codingList.$el
      }

      this.tableToCsv(table, 'account_numbers.csv', headers)
    },

    sortByOrder(a, b) {
      const aOrder = a.orderField
      const bOrder = b.orderField
      let comparison = 0
      if (aOrder > bOrder) {
        comparison = 1
      } else {
        comparison = -1
      }
      return comparison
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    getAccountData() {
      if (this.reviewType === 'ip') {
        return this.filterList(this.dashboardAccounts, this.filterCriteria, ['dschDate', 'patNum', 'payName', 'description', 'orDrg', 'neDrg']).sort(this.sortByOrder)
      } else {
        return this.filterList(this.dashboardAccounts, this.filterCriteria).sort(this.sortByOrder)
      }
    },
    handleViewPsiQmReviewAccountNumbers() {
      let payload = {
        reviewType: this.reviewType,
        accountNumbers: this.row[this.tableType]
      }
      this.loading = true
      this.GET_DASHBOARD_ACCOUNTS(payload).then(x => {
        this.loading = false
      })
    },
    getPatNumDisplay(row) {
      console.log(this.$route.name === 'my-projects')
    },
    handleLoad() {
      if ((this.isOpen || this.isModal) && this.tableType === 'accountNumbers') {
        this.handleViewAccountNumbers()
      }
      if (this.isOpen && this.tableType === 'dxDashboard') {
        this.handleDxDashboard()
      }
      if (this.isOpen && ['additionsAccounts', 'deletionsAccounts', 'noRecAccounts'].some(s => s === this.tableType)) {
        this.handleViewPsiQmReviewAccountNumbers()
      }
    }
  },
  mounted: function() {
    if (this.isModal) {
      console.log('mounted')
      this.loading = true
      this.handleLoad()
    }
  },
  computed: {
    ...mapState('dashboard/', ['dashboardData', 'dashboardProjects', 'reviewDashboardData', 'dxModalData', 'dashboardAccounts', 'codingDateRange']),
    ...mapState('user/', ['currentClient', 'currentClientId']),

    localDashboardAccounts() {
      if (this.dashboardAccounts.length) {
        return this.getAccountData()
      }
      return []
    },
    dashboardAccountsPagination() {
      let length = this.localDashboardAccounts.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.localDashboardAccounts.slice(from, to)
    }
  },
  watch: {
    isOpen(val) {
      if (!val) {
        this.selectedRecordId = null
      }
      this.handleLoad()
    }
  }
}
</script>

<style scoped>
.viewAccountNumbers {
  margin: 0px 0px 0px 0px;
  position: absolute;
  z-index: 999;
  right: 15px;
}

.tableIcon {
  font-size: 16px;
  float: left;
  height: 12px;
  margin: -3px 5px 0 0;
}

.details-popover >>> .worksheet-button-group {
  display: inline-flex;
  vertical-align: middle;
  align-items: stretch;
}

.details-popover >>> .worksheet-button-group .el-button {
  height: 32px !important;
  min-height: 32px !important;
  line-height: 1 !important;
  padding: 0 12px !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  float: none !important;
  box-sizing: border-box !important;
}

.details-popover >>> .worksheet-button-group .el-button + .el-button {
  margin-left: -1px !important;
}

.details-popover >>> .worksheet-button-group .el-button:first-child {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-top-left-radius: 30px !important;
  border-bottom-left-radius: 30px !important;
}

.details-popover >>> .worksheet-button-group .el-button:last-child {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-top-right-radius: 30px !important;
  border-bottom-right-radius: 30px !important;
  width: 32px !important;
  min-width: 32px !important;
  padding: 0 !important;
}

.details-popover >>> .worksheet-button-group .tableIcon {
  float: none !important;
  display: inline-block;
  height: auto;
  margin: 0 4px 0 0;
  vertical-align: middle;
  line-height: 1;
  font-size: 14px;
}

.details-popover >>> .worksheet-button-group .worksheet-button-group-action .tableIcon {
  margin: 0;
}

#documentTableStats p {
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 0px 0px;
  font-size: 12px;
  font-weight: normal;
  color: #606266;
}

.details-popover-title {
  font-weight: 700;
}

/* Bold all Element table column headers in this popover (pivot, account lists, Dx summary, coding). */
.details-popover >>> .el-table thead th .cell {
  font-weight: 700 !important;
  color: #606266 !important;
}

.details {
  text-decoration: underline;
  text-decoration-style: dotted;
  cursor: pointer;
}

>>> th .cell,
>>> td .cell {
  word-break: break-word;
}

.record-detail-panel {
  clear: both;
  border-top: 1px solid #dcdfe6;
  margin-top: 10px;
  padding-top: 10px;
}

.record-detail-panel-title {
  text-align: left;
  margin: 0 0 10px 10px;
}
</style>
